import { render, staticRenderFns } from "./SelectPixelRule.vue?vue&type=template&id=3d46731a&scoped=true"
import script from "./SelectPixelRule.vue?vue&type=script&lang=js"
export * from "./SelectPixelRule.vue?vue&type=script&lang=js"
import style0 from "./SelectPixelRule.vue?vue&type=style&index=0&id=3d46731a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d46731a",
  null
  
)

export default component.exports